import { TFunction } from 'i18next';

export type TranslationTParams = Parameters<TFunction>
export type Translation = Record<string, TranslationTParams>;

const TRANSLATIONS = {
  JOINED_ROOMS: {
    ANNOUNCEMENT: ['chat.joined_rooms.announcement', 'Announcements'],
    GROUP: ['chat.joined_rooms.group', 'Booth Chat Rooms'],
    PUBLIC: ['chat.joined_rooms.public', 'Public Chat Rooms'],
    PRIVATE: ['chat.joined_rooms.private', 'Direct Messages'],
  },
  STATE: {
    CONNECTING: ['chat.state.connecting', 'Connecting...'],
    CONNECTED: ['chat.state.connected', 'Successfully Connected!'],
    DISCONNECTING: ['chat.state.disconnecting', 'Re-connecting...'],
    DISCONNECTED: ['chat.state.disconnected', 'Disconnected'],
    DENIED: ['chat.state.denied', 'Declined Connection'],
    ONLINE: ['chat.is_online', 'Online'],
  },
  ERRORS: {
    RENDER: ['chat.render_error', 'Oops, an unknown error has occurred. Please try refreshing. If this problem persists, please contact us via help button.'],
    UPLOAD_FAIL: ['chat.upload_fail', 'Failed to upload file'],
    UPLOAD_ERROR: ['chat.upload_error', 'Upload Error'],
    LEAVE_FAIL: ['chat.leave_fail', 'Failed to leave chat room'],
    NO_EXHIBITOR_INTERACTION: ['chat.no_exhibitor_interaction', 'The organizer has disabled the inter-exhibitor interaction feature'],
    JOIN_FAIL: ['chat.join_fail', 'Failed to join chat room'],
    CONNECTION: ['chat.connection_error', 'An error occurred during the connection process'],
    VIDEO_ROOM_CREATE_FAIL: ['chat.video_room_create_fail', 'Failed to create video call room'],
    ANNOUNCEMENT_FAIL: ['chat.announcement_fail', 'Failed to send announcement, please check your permissions'],
  },
  CONTACT: {
    VIEW: ['contact.view_more', 'View More'],
    ADD: ['contact.add_to_my_contacts', 'Add to My Contacts'],
  },
  COMMON: {
    CHAT: ['chat.chat', 'Messages'],
    ONE_CLICK: ['chat.one_click_msg', 'Join a chat room and chat with people now!'],
    NO_MESSAGES: ['chat.no_message', 'No messages yet'],
    UNREAD: ['chat.unread_messages', '%{unreadCount} unread message(s)'],
    NOTIFICATION: ['chat.notification_sound', 'Notification Sound Settings'],
    ROOM_MEMBERS: ['chat.members', 'Chat Room Members'],
    LEAVE_GROUP_SUCCESS: ['chat.leave_group_success', 'You have left the chat room'],
    LEAVE_CHAT: ['chat.leave_chat', 'Leave the Chat Room?'],
    PERSON_JOINED: ['chat.person_joined', '%{person} joined'],
    PERSON_LEFT: ['chat.person_left', '%{person} left'],
    ANNOUNCEMENT_PROCESSING: ['chat.announcement_processing', 'Broadcasting your announcement'],
    ANNOUNCEMENT_SUCCESS: ['chat.announcement_success', 'Announcement sent'],
    FILE_LIMIT: ['chat.file_limit', 'File size should not exceed 10 MB'],
    CONTACT_CARD_THROTTLE: ['chat.contact_card_throttle', 'Maximum 1 Contact Card per 5 seconds'],
    TODAY: ['chat.today', 'Today'],
    YTD: ['chat.ytd', 'Yesterday'],
    YOU_PREFIX: ['chat.you_prefix', 'You: %{content}'],
    PREVIEW: ['chat.preview', 'Preview'],
    FILE_PREVIEW: ['chat.file_preview', '[File]'],
    CONTACT_CARD_PREVIEW: ['chat.card_preview', '[Contact Card]'],
    MESSAGE_TIMESTAMP_AM: ['chat.message_timestamp_am', '%{time} AM'],
    MESSAGE_TIMESTAMP_PM: ['chat.message_timestamp_pm', '%{time} PM'],
  },
  VIDEO_CALL: {
    DURATION: ['call.duration', 'Duration: %{duration}'],
  },
} as const;

export default TRANSLATIONS;
